<template>
  <div class="publicMain" style="position: relative;" v-loading="loading" :element-loading-text="loadingText"
       element-loading-background="rgba(250, 250, 250, 1)">
    <div class="mianbao">
      <!--  -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>养老服务机构</el-breadcrumb-item>
        <el-breadcrumb-item>机构养老</el-breadcrumb-item>
        <el-breadcrumb-item>地图分布</el-breadcrumb-item>
      </el-breadcrumb>
    </div>


    <!--  -->
    <!-- <div class='back'>返回</div> -->
    <!-- 服务公司的模板 -->




    <!-- 机构养老的模板 -->
    <div
        v-for="(item,index) in provideArr.length>0?provideArr:provideArrCopy"
        :key="index"
        ref="provideRef"
        @click="provideTemplateClick(item)"
        class="father"
    >
      <img :src="provide" alt srcset style="width: 50px;height: 50px;"/>
      <span style="font-size:12px">养老机构</span>
    </div>

    <div id="container"></div>
    <!--    机构信息-->
    <el-dialog title="机构信息" :visible.sync="dialogVisible" width="50%">
      <provideImageDialog1 v-if="dialogVisible" :row="row"/>
    </el-dialog>

  </div>
</template>

<script>
import provideImageDialog1 from "./components/provideImageDialog1.vue";
import provideImageDialog2 from "./components/provideImageDialog2.vue";
import provideImageDialog3 from "./components/provideImageDialog3.vue";
//图标
import community from "@/assets/images/map/community.png";
import homeProvide from "@/assets/images/map/homeProvide.png";
import oldMan from "@/assets/images/map/oldMan.png";
import provide from "@/assets/images/map/provide.png";
import serveCompany from "@/assets/images/map/serveCompany.png";
import servePeople from "@/assets/images/map/servePeople.png";
import {post} from "@/api/requrestHttp";
import axios from "axios";
import {
  getHeKangObject,
  getHeKangPeople,
  getHeKangWorkOrder, oldManFileList,
  organizationPeopleList,

} from "./api";
import {
  organizationInfoList,
  communityInfoList,
} from "./api";

const request = axios.create();
export default {
  components: {
    provideImageDialog1,
    provideImageDialog2,
    provideImageDialog3
  },
  data() {
    return {
      request,
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      checkObject: {
        checked1: true,
        checked2: true,
        checked3: true,
        checked4: true,
        checked5: true,
      },
      // checked: false,
      // checked1: false,
      // checked2: false,
      // checked3: false,
      // checked4: false,
      // checked5: false,
      community,
      homeProvide,
      oldMan,
      provide,
      serveCompany,
      servePeople,
      map: {},
      marker: {},
      markers: {},
      marker1: {},
      markers1: {},
      checked: false,
      showTemplate: false,
      // //服务公司的列表
      companyArr: [
        // {
        //     position: [117.558033, 32.857098],
        //     name: "服务公司",
        //     show: false,
        // },
      ],
      //服务公司的列表拷贝
      companyArrCopy: [
        // {
        //     position: [117.558033, 32.857098],
        //     name: "服务公司",
        //     show: false,
        // },
      ],
      //老人的列表
      oldManArr: [
        {
          position: [117.563987, 32.857027],
          name: "老人",
          show: false,
        },
      ],
      //老人的列表拷贝
      oldManArrCopy: [
        {
          position: [117.563987, 32.857027],
          name: "老人",
          show: false,
        },
      ],
      //服务人员的列表
      servePeopleArr: [
        {
          position: [117.562818, 32.859234],
          name: "机构服务人员",
          show: false,
        },
      ],
      //服务人员的列表拷贝
      servePeopleArrCopy: [
        {
          position: [117.562818, 32.859234],
          name: "机构服务人员",
          show: false,
        },
      ],
      //机构养老的列表
      provideArr: [
        {
          position: [117.569987, 32.860027],
          name: "机构养老",
          show: false,
        },
      ],
      //机构养老的列表拷贝
      provideArrCopy: [
        {
          position: [117.569987, 32.860027],
          name: "机构养老",
          show: false,
        },
      ],
      //社区养老的列表
      communityArr: [
        {
          position: [117.564987, 32.864027],
          name: "社区养老",
          show: false,
        },
      ],
      //社区养老的列表拷贝
      communityArrCopy: [
        {
          position: [117.564987, 32.864027],
          name: "社区养老",
          show: false,
        },
      ],
      itemArr: [],
      coordArr: [],
      openName: "收起",
      input: "",
      row: {},
      loading: true,
      loadingText: '地图初始化中...',
    };
  },

  methods: {
    mapInit() {
      let that = this;
      that.map = new AMap.Map("container", {
        resizeEnable: true, //是否监控地图容器尺寸变化
        // zoom: 15, //初始化地图层级
        zoom: 16,
        zooms: [3, 20],
        mapStyle: "amap://styles/darkblue", // 地图主题
        // center: [119.01376,32.688719], //中心点
        center: [118.004542,32.779366], //中心点
      });

      /***********渲染网格*********/

      that.coordArr.forEach((item) => {
        let polygonArr = [];
        item.arr.split(",").forEach((es) => {
          polygonArr.push(es.split(":"));
        });
        var polygon = new AMap.Polygon({
          map: that.map,
          path: polygonArr, //设置多边形边界路径
          strokeColor: "#" + item.color, //线颜色
          strokeOpacity: 0.2, //线透明度
          strokeWeight: 3, //线宽
          fillColor: "#" + item.color, //填充色
          fillOpacity: 0.2, //填充透明度
          extData: {
            name: "治东社区",
            address: "安徽省淮南市治东社区第五网格",
            tel: "0556-1231231",
          },
        });
        //点击事件
        // polygon.on("click", function (e) {
        //   that.$emit("setOrgId", item.id);
        // });
        //变色
        polygon.on("mouseover", function (e) {
          this.setOptions({
            strokeOpacity: 0.8, //线透明度
            strokeWeight: 5, //线宽
            fillOpacity: 0.5, //填充透明度
          });
        });
        polygon.on("mouseout", function () {
          this.setOptions({
            strokeOpacity: 0.2, //线透明度
            strokeWeight: 3, //线宽
            fillOpacity: 0.35, //填充透明度
          });
        });
      });
      /*******************/




      //机构养老的mark标记出来
      this.provideArr.forEach((item, index) => {
        let marker = new AMap.Marker({
          position: item.position,
          // 将 html 传给 content
          content: that.$refs.provideRef[index],
          // 以 icon 的 [center bottom] 为原点
          offset: new AMap.Pixel(0, 0),
        });
        //添加点标记
        that.map.add(marker);
      });

      //地图完成
      this.loading = false
    },






    //机构养老
    provideTemplateClick(e) {
      this.row = e
      this.dialogVisible = true;
    },
    //社区养老
    communityTemplateClick(e) {
      this.row = e
      this.dialogVisible2 = true;
    },
    ////拿到每个网格的边界数据
    getEchartList() {
      // post("/admin/statistics/info/findZdOrg", {}).then((res) => {});
      return new Promise((resolve) => {
        post("/admin/statistics/info/findZdOrg", {}).then((res) => {
          resolve(res);
        });
      });
    },
    //展开
    open() {
      if (this.openName == "展开") {
        this.$refs.top.style.height = "318px";
        this.openName = "收起";
      } else {
        this.$refs.top.style.height = "55px";
        this.openName = "展开";
      }
    },
    //
    search() {
      let arr = this.companyArr.concat(
          this.oldManArr,
          this.servePeopleArr,
          this.provideArr,
          this.communityArr
      );
      let index = arr.findIndex((item) => item.name == this.input);
      if (this.input == "") {
        this.mapInit();
      } else if (index > -1) {
        this.mapInit(arr[index].position);
      } else {
        this.$message({
          message: "没有搜索到你想要的内容，请重新输入",
          type: "warning",
        });
      }
      //
    },


    //拿到机构列表
    provideManageAPI(e) {
      let params = {
        pageNo: 1,
        pageSize: 10000
      }
      return new Promise(resolve => {
        organizationInfoList(params).then(res => {
          resolve(res)
        });
      })
    },

  },
  created() {
    this.loading = true
    loadingText:'正在初始化数据...'
  },
  async mounted() {
    //开启遮罩层
    this.loading = true
    loadingText:'正在初始化数据...'
    let arr2 = await this.provideManageAPI()
    // //拿到老人 服务 社区 机构等数据 然后存储一份 等待地图mark


    this.provideArr = arr2.content.list.map(item => {
      return {
        position: [Number(item.longitude), Number(item.latitude)],
        name: "机构养老",
        show: false,
        id: item.id
      }
    })
    this.provideArrCopy = arr2.content.list.map(item => {
      return {
        position: [Number(item.longitude), Number(item.latitude)],
        name: "机构养老",
        show: false,
        id: item.id
      }
    })

    //
    loadingText:'正在初始化地图信息...',
        this.$nextTick(() => {
          this.getEchartList().then((res) => {
            this.itemArr = [];
            this.coordArr = [];
            //处理数据
            res.content.forEach((item) => {
              let coodrListArr = [];
              if (item.gridOfficeCordinate) {
                if (item.gridOfficeCordinate.split("%").length > 1) {
                  item.gridOfficeCordinate.split("%").forEach((e) => {
                    this.itemArr.push(e.split(","));
                  });
                } else {
                  this.itemArr.push(item.gridOfficeCordinate.split(","));
                }
              }
              if (item.pointPosition) {
                if (item.pointPosition.split("%").length > 1) {
                  item.pointPosition.split("%").forEach((e) => {
                    let obj = {
                      color: item.gridColour,
                      arr: e,
                      id: item.id,
                    };
                    this.coordArr.push(obj);
                  });
                } else {
                  let obj = {
                    color: item.gridColour,
                    arr: item.pointPosition,
                    id: item.id,
                  };
                  this.coordArr.push(obj);
                }
              }
            });
            this.mapInit();
          });
        });
  },
  watch: {
    checkObject: {
      handler(newV, oldV) {
        //选择渲染不同类型的标记
        if (!newV.checked1) {
          this.oldManArr = [];
        } else {
          this.oldManArr = this.oldManArrCopy;
        }
        if (!newV.checked2) {
          this.provideArr = [];
        } else {
          this.provideArr = this.provideArrCopy;
        }
        if (!newV.checked3) {
          this.communityArr = [];
        } else {
          this.communityArr = this.communityArrCopy;
        }
        if (!newV.checked4) {
          this.companyArr = [];
        } else {
          this.companyArr = this.companyArrCopy;
        }
        if (!newV.checked5) {
          this.servePeopleArr = [];
        } else {
          this.servePeopleArr = this.servePeopleArrCopy;
        }
        this.mapInit();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
#container {
  width: 100%;
  height: calc(100vh - 120px);
}

.mianbao {
  margin: 0px;
}

.custom-content-marker {
  background-color: blue;
}

.close-btn {
  color: red;
}

.image1 {
  position: absolute;
  top: 152px;
  left: 180px;
  width: 100px;
  height: 100px;
  background-color: yellow;
  z-index: 100000000;
}

.image2 {
  position: absolute;
  top: 172px;
  left: 619px;
  width: 100px;
  height: 100px;
  background-color: yellow;
  z-index: 100000000;
}

.father {
  /* width: 50px;
    height: 50px; */
  position: relative;
  left: -25px;
  top: -25px;
  color: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: normal;
  word-break: break-all;
  font-size: 14px;
  text-align: center;
  position: relative;
  flex-direction: column;
}

.company {
  position: absolute;
  width: 200px;
  background: rgba(0, 0, 0, 0.8);
  /* right: -200px;
  top: -50%;
  transform: translateY(-50%); */
  color: #fff;
  top: 100%;
  left: 70px;
  transform: translateY(-63%);
  border-radius: 10px;
}

.son2 {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  padding: 10px 10px;
  border-bottom: 1px solid rgb(220, 220, 220);
}

.oldTitle2 {
  display: flex;
  padding: 10px;
  justify-content: space-between;
}

.oldTitle2-1 {
  padding: 10px;
  background-color: rgba(220, 220, 220, 0.5);
  border-radius: 10px;
}

.oldTitle2-2 {
  padding: 10px;
  background-color: rgba(220, 220, 220, 0.5);
  border-radius: 10px;
}

.servePeople {
  position: absolute;
  width: 300px;
  background: rgba(0, 0, 0, 0.8);
  right: -325px;
  top: 50%;
  transform: translateY(-50%);
  color: #fff;
  border-radius: 10px;
}

.triangle {
  width: 0;
  height: 0;
  border: 20px solid;
  border-color: transparent rgba(0, 0, 0, 0.8) transparent transparent;
  position: absolute;
  left: -40px;
  top: 50%;
  transform: translateY(-50%);
}

.right {
  width: 260px;
  height: 318px;
  position: absolute;
  z-index: 1000;
  background-color: rgba(120, 120, 120, 0.8);
  top: 45px;
  right: 20px;
  transition: all 0.4s;
  overflow: hidden;

}

.el-checkbox {
  color: #fff;
}

.checkbox {
  /* text-align: center; */
  margin: 30px 0px;
  padding-left: 30px;
}

.el-checkbox__label {
  margin-left: 10px;
}

.top {
  width: 260px;
  position: absolute;
  z-index: 1000;
  background-color: rgba(100, 100, 100, 0.8);
  top: 45px;
  left: 20px;
  transition: all 0.4s;
  overflow: hidden;

}

.top-context {
  text-align: center;
  margin: 10px 0px;
  display: flex;
  padding-left: 30px;
}

.context {
  height: 30px;
  border-radius: 10px;
  outline: none;
  color: 1px solid rgb(164, 164, 164);
  font-size: 12px;
  width: 100px;
  padding-left: 20px;
  border: none;
}

.top-span {
  font-size: 14px;
  color: rgb(64, 158, 255);
  line-height: 30px;
  margin-left: 10px;
  cursor: pointer;
}

.back {
  position: absolute;
  right: 30px;
  top: 70px;
  padding: 10px 20px;
  z-index: 400;
  background-color: rgb(164, 164, 164);
  border-radius: 10px;
  cursor: pointer;
}
</style>